import { ReactNode } from 'react';
import { StyleSheet, Pressable, ImageURISource } from 'react-native';

import { colors, spacing } from '../../theme';
import { usePressable } from '../../hooks';
import { UserInfo } from '../UserInfo';

interface Props {
	name: string;
	photoSource?: ImageURISource;
	onPress?: () => void;
	action?: ReactNode;
	disabled?: boolean;
}

export const ContactItem = ({ name, photoSource, onPress, action, disabled }: Props) => {
	const { isHovered, onHoverIn, onHoverOut } = usePressable();

	return (
		<Pressable
			style={[styles.root, isHovered && styles.hovered]}
			onHoverIn={onHoverIn}
			onHoverOut={onHoverOut}
			onPress={onPress}
			disabled={disabled}
		>
			<UserInfo name={name} photoSource={photoSource} onPress={onPress} disabled={disabled} />
			{action}
		</Pressable>
	);
};

const styles = StyleSheet.create({
	root: {
		flexDirection: 'row',
		justifyContent: 'space-between',
		marginTop: spacing(),
		padding: spacing(),
		borderRadius: spacing(),
	},
	hovered: {
		backgroundColor: colors.neutral,
	},
});
